import { useEffect, useState } from 'react';

export function useIsScrolledUnderHeader(
  target: HTMLElement | null,
  header: HTMLElement | null,
): boolean {
  const [isScrolledUnder, setIsScrolledUnder] = useState(false);

  useEffect(() => {
    if (target === null || header === null) return undefined;
    const headerHeight = header.getBoundingClientRect().height;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry === undefined) return;
        setIsScrolledUnder(!entry.isIntersecting && entry.boundingClientRect.top < headerHeight);
      },
      { rootMargin: `-${String(headerHeight)}px 0px 0px 0px` },
    );
    observer.observe(target);
    return () => observer.disconnect();
  }, [target, header]);

  return target !== null && header !== null && isScrolledUnder;
}
